
import { MToolboxPermit } from './toolbox-permit.model';
import { OrganizationUserGet } from '../interfaces/Organization';

export class MOrganizationUser{
    id: number;
    username: string;
    name: string;
    email: string;
    toolboxes: MToolboxPermit[];

    constructor(user: OrganizationUserGet){
        this.id = user.usuario.id;
        this.username = user.usuario.username;
        this.name = user.usuario.name;
        this.email = user.usuario.email;
        this.toolboxes = []
        for (let i = 0; i < user.permiso_toolboxes.length; i++) {
            this.toolboxes.push(new MToolboxPermit(user.permiso_toolboxes[i]))
        }
    }
}